'use strict'

window.SharedOrderProductFunctions = {
    productRowForRel: null,
    activeProduct: null,
    SelectProduct: function (productID) {
        $.ajax({
            type: "GET",
            url: '/legacy/Orders/GetProductForOrderByID',
            data: {
                id: productID,
                Date: $('#DateOfImplementation').val()
            },
            dataType: 'json',
            async: false,
            success: function (data) {
                if (data.AllOk) {
                    const amountOfProceduresInOrder = $('#nrSelectedProcedures').text()
                    if (amountOfProceduresInOrder == 1)
                    {
                        //set first and only procedure as linked procedure
                        SharedOrderProductFunctions.AddProduct(data.Product);                

                        fillManualRelativeProvisionDialog(false);
                        var productRow = $('tr#selectedProduct' + SharedOrderProductFunctions.productRowForRel);
                        var selectedRadio = $('input[name=procForRelProduct]').parent().parent();

                        var orderProcUID = selectedRadio.find('.procForRelOrderProc_UID').val();
                        var procUID = selectedRadio.find('.procForRelProduct_UID').val();
                        var procCode = selectedRadio.find('.procForRelProduct_Code').val();
                        var procModality = selectedRadio.find('.procForRelProduct_Modality').val();
                        var procColor = selectedRadio.find('.procForRelProduct_Color').val();
                        var description = selectedRadio.find('.procForRelProduct_Description').val();

                        let toAppend = '<b>' + procModality + '</b> ' + procCode;
                        toAppend += '<input type="hidden" class="productRelOrderProcedureUID" name="Products[0].RelOrderProcedure_UID" value="' + orderProcUID + '" />';
                        toAppend += '<input type="hidden" class="productRelProcedure_UID" name="Products[0].RelProcedure_UID" value="' + procUID + '" />';
                        toAppend += '<input type="hidden" class="productRelProcedureCode" name="Products[0].RelProcedureCode" value="' + procCode + '" />';
                        toAppend += '<input type="hidden" class="productRelProcedureModality" name="Products[0].RelProcedureModality" value="' + procModality + '" />';
                        toAppend += '<input type="hidden" class="productRelativeProvision" name="Products[0].RelativeProvision" value="true" />';
                        toAppend += '<input type="hidden" class="productRelProcedureColor" name="Products[0].RelProcedureColor" value="' + procColor + '" />';
                        toAppend += '<input type="hidden" class="productRelProcedureDescription" name="Products[0].RelProcedureDescription" value="' + description + '" />';

                        productRow.find('td.relProcCol').css('background-color', procColor);
                        productRow.find('td.relProcCol').html(toAppend);
                        productRow.find('td.relProcCol').attr('title', description);

                        SharedOrderProductFunctions.SortSelectedProducts();
                        SharedOrderFunctions.GetInvoiceInformation(true);
                    }
                    else
                    {
                        //ask which procedure should be linked to the product
                        showManualRelativeProvisionDialog(data.Product);
                    }
                }
            }
        });
    },
    AddProduct: function (pr, orderProcedure_UID) {
        let productRowForRel = guid();
        SharedOrderProductFunctions.productRowForRel = productRowForRel;
        let toAppend = '<tr class="selectedProductItem tableRecord toEdit disNone" id="selectedProduct' + productRowForRel + '">';
        toAppend += '<td class="center pr5">';
        toAppend += '<input class="productAmount toEdit dis disNone" value="' + pr.Amount + '" name="Products[0].Amount" type="number"/>';
        toAppend += '</td>';
        toAppend += '<td class="pr35">';
        toAppend += pr.ProductCode + ' -  ' + pr.ProductDescription + ' (' + pr.ProductPharmacyNumber + ')';
        toAppend += '<input type="hidden" class="productUID" name="Products[0].Product_UID" value="' + pr.Product_UID + '" />';
        toAppend += '<input type="hidden" class="productCode" name="Products[0].ProductCode" value="' + pr.ProductCode + '" />';
        toAppend += '<input type="hidden" class="productDescription" name="Products[0].ProductDescription" value="' + pr.ProductDescription + '" />';
        pr.Nomenclatures.forEach((n,i) => {
            toAppend += '<input type="hidden" class="productNomenclatures" name="Products[0].Nomenclatures['+i+']" value="' + n + '" />';
        });
        toAppend += '<input type="hidden" class="productPharmacyNumber" name="Products[0].ProductPharmacyNumber" value="' + pr.ProductPharmacyNumber + '" />';
        toAppend += '<input type="hidden" class="productGUID" name="Products[0].GUID" value="' + productRowForRel + '" />';
        toAppend += '<input type="hidden" class="productOrderHasProduct_UID" name="Products[0].Order_HasProduct_UID" value="' + pr.Order_HasProduct_UID + '" />';
        toAppend += '</td>';
        toAppend += '<td class="pr15">';
        if (pr.ProductRemarks && pr.ProductRemarks.length)
        {
            toAppend += '<select class="productRemark dropdownValue dis" name="Products[0].ProductRemark_UID">';
            toAppend += '<option value=""></option>';
            $.each(pr.ProductRemarks, function (i, remark) {
                if ((!pr.ProductRemark_UID && remark.ID == pr.DefaultRemarkUID) || remark.ID == pr.ProductRemark_UID) {
                    toAppend += '<option value="' + remark.ID + '" selected="selected">' + remark.Name + '</option>';
                }
                else {
                    toAppend += '<option value="' + remark.ID + '">' + remark.Name + '</option>';
                }
            });
        }
        toAppend += "</select>";
        toAppend += '</td>';
        toAppend += '<td class="pr10">';
        toAppend += '<input class="productLotNumber" name="Products[0].ProductLotNumber" value="' + pr.ProductLotNumber + '" type="text" />';
        toAppend += '</td>';
        toAppend += '<td class="pr10">';
        toAppend += '<input class="productAdministered toEdit dis disNone" name="Products[0].Administered" value="' + pr.Administered + '" type="number" min="0"/> ';
        toAppend += pr.MeasuringUnit
        toAppend += '<input type="hidden" class="productMeasuringUnit" name="Products[0].MeasuringUnit" value="' + pr.MeasuringUnit + '" />';
        toAppend += '</td>';
        if (pr.FromProcedureCode != null) {
            toAppend += '<td class="pr10 center fromProcedureCol" style="background-color: ' + pr.FromProcedureColor + ';" title="' + pr.FromProcedureDescription + '">';
            toAppend += '<div class="procedureName">' + '<b>' + pr.FromProcedureModality + '</b> ' + pr.FromProcedureCode + '</div>';
            toAppend += '<input type="hidden" class="productFromOrderProcedureUID" name="Products[0].FromOrderProcedure_UID"';
            if (pr.FromOrderProcedure_UID != null) {
                toAppend += 'value="' + pr.FromOrderProcedure_UID + '"';
            }
            toAppend += '/>';
            toAppend += '<input type="hidden" class="productFromProcedureUID" name="Products[0].FromProcedure_UID" value="' + pr.FromProcedure_UID + '" />';
            toAppend += '<input type="hidden" class="productFromProcedureModality" name="Products[0].FromProcedureModality" value="' + pr.FromProcedureModality + '" />';
            toAppend += '<input type="hidden" class="productFromProcedureCode" name="Products[0].FromProcedureCode" value="' + pr.FromProcedureCode + '" />';
            toAppend += '<input type="hidden" class="productFromProcedureColor" name="Products[0].FromProcedureColor" value="' + pr.FromProcedureColor + '" />';
            toAppend += '<input type="hidden" class="productFromProcedureDescription" name="Products[0].FromProcedureDescription" value="' + pr.FromProcedureDescription + '" />';
            toAppend += '</td>';
        }
        else {
            toAppend += '<td class="pr10 center">&nbsp;</td>';
        }
        if (pr.RelativeProvision && pr.RelProcedureCode != null) {
            toAppend += '<td class="pr10 center relProcCol" style="background-color: ' + pr.RelProcedureColor + ';" title="' + pr.RelProcedureDescription + '">';
            toAppend += '<div class="procedureName">' + '<b>' + pr.RelProcedureModality + '</b> ' + pr.RelProcedureCode + '</div>';
            toAppend += '<input type="hidden" class="productRelOrderProcedureUID" name="Products[0].RelOrderProcedure_UID"';
            if (pr.RelOrderProcedure_UID != null) {
                toAppend += 'value="' + pr.RelOrderProcedure_UID + '"';
            }
            toAppend += '/>';
            toAppend += '<input type="hidden" class="productRelProcedure_UID" name="Products[0].RelProcedure_UID" value="' + pr.RelProcedure_UID + '" />';
            toAppend += '<input type="hidden" class="productRelProcedureCode" name="Products[0].RelProcedureCode" value="' + pr.RelProcedureCode + '" />';
            toAppend += '<input type="hidden" class="productRelProcedureModality" name="Products[0].RelProcedureModality" value="' + pr.RelProcedureModality + '" />';
            toAppend += '<input type="hidden" class="productRelativeProvision" name="Products[0].RelativeProvision" value="' + pr.RelativeProvision + '" />';
            toAppend += '<input type="hidden" class="productRelProcedureColor" name="Products[0].RelProcedureColor" value="' + pr.RelProcedureColor + '" />';
            toAppend += '<input type="hidden" class="productRelProcedureDescription" name="Products[0].RelProcedureDescription" value="' + pr.RelProcedureDescription + '" />';
            toAppend += '</td>';
        }
        else if (pr.RelativeProvision && pr.RelProcedureCode == null) {
            toAppend += '<td class="pr10 center relProcCol">';
            toAppend += '<span class="chooseRelProv">' + Resources.ChooseProcedure + '</span>';
            toAppend += '<input type="hidden" class="productRelativeProvision" name="Products[0].RelativeProvision" value="' + pr.RelativeProvision + '" />';
            toAppend += '</td>';
        }
        else {
            toAppend += '<td class="pr10 center relProcCol">&nbsp;</td>';
        }
        toAppend += '<td class="pr5 delete">Resources.Delete</td>';
        toAppend += '</tr>';

        var node = document.createElement("template");
        node.innerHTML = toAppend;
        node = node.content.firstChild;

        const amountNode = node.querySelector(".productAmount");
        SharedOrderProductFunctions.clampNumberInputAndAttachListener(amountNode, 0, null, 0, () => {
            SharedOrderFunctions.GetInvoiceInformation(true);
        });

        $('#selectedProducts').append(node);

        const promises = [];
        
        $.each(pr.ExportFormats, function (i, ef) {
            promises.push(AddProductExportFormat(i, ef, productRowForRel));
        });
        
        return new Promise(function(resolve) { Promise.all(promises).then(function() { resolve(); } ) } );
    },
    SelectProductFromProcedure: function (productID, procedureID) {
        $.ajax({
            type: "GET",
            url: '/legacy/Orders/GetProductFromProcedureForOrder',
            data: {
                Product_UID: productID,
                Procedure_UID: procedureID
            },
            dataType: 'json',
            async: false,
            success: function (data) {
                if (data.AllOk) {
                    SharedOrderProductFunctions.AddProduct(data.Product);
                    SharedOrderProductFunctions.SortSelectedProducts();
                    SharedOrderFunctions.GetInvoiceInformation(true);
                }
            }
        });
    },
    SortSelectedProducts: function () {        
        const products = $('#selectedProducts').find('tr.selectedProductItem');
        const total = products.length;
        if (total === 0) {
            $('table#selectedProducts tr#emptyTable').show();
        }
        else {
            $('table#selectedProducts tr#emptyTable').hide();
        }
        $('#nrSelectedProducts').text(total);

        $.each(products, function (i, obj) {
            $(products[i]).find('input.productAmount').attr('name', 'Products[' + i + '].Amount');
            $(products[i]).find('input.productUID').attr('name', 'Products[' + i + '].Product_UID');
            $(products[i]).find('input.productCode').attr('name', 'Products[' + i + '].ProductCode');
            $(products[i]).find('input.productDescription').attr('name', 'Products[' + i + '].ProductDescription');
            $(products[i]).find('input.productNomenclatures').each((t, x) => $(x).attr('name', 'Products[' + i + '].Nomenclatures[' + t + ']'));
            $(products[i]).find('input.productPharmacyNumber').attr('name', 'Products[' + i + '].ProductPharmacyNumber');
            $(products[i]).find('input.productGUID').attr('name', 'Products[' + i + '].GUID');
            // TODO difference
            $(products[i]).find('input.productOrderHasProduct_UID').attr('name', 'Products[' + i + '].Order_HasProduct_UID');

            $(products[i]).find('input.productAdministered').attr('name', 'Products[' + i + '].Administered');
            $(products[i]).find('input.productMeasuringUnit').attr('name', 'Products[' + i + '].MeasuringUnit');

            // TODO difference
            $(products[i]).find('input.productFromOrderProcedureUID').attr('name', 'Products[' + i + '].FromOrderProcedure_UID');
            $(products[i]).find('input.productFromProcedureUID').attr('name', 'Products[' + i + '].FromProcedure_UID');
            $(products[i]).find('input.productFromProcedureModality').attr('name', 'Products[' + i + '].FromProcedureModality');
            $(products[i]).find('input.productFromProcedureCode').attr('name', 'Products[' + i + '].FromProcedureCode');
            $(products[i]).find('input.productFromProcedureColor').attr('name', 'Products[' + i + '].FromProcedureColor');
            $(products[i]).find('input.productFromProcedureDescription').attr('name', 'Products[' + i + '].FromProcedureDescription');

            // TODO difference
            $(products[i]).find('input.productRelOrderProcedureUID').attr('name', 'Products[' + i + '].RelOrderProcedure_UID');
            $(products[i]).find('input.productRelProcedure_UID').attr('name', 'Products[' + i + '].RelProcedure_UID');
            $(products[i]).find('input.productRelProcedureCode').attr('name', 'Products[' + i + '].RelProcedureCode');
            $(products[i]).find('input.productRelProcedureModality').attr('name', 'Products[' + i + '].RelProcedureModality');
            $(products[i]).find('input.productRelativeProvision').attr('name', 'Products[' + i + '].RelativeProvision');
            $(products[i]).find('input.productRelProcedureColor').attr('name', 'Products[' + i + '].RelProcedureColor');
            $(products[i]).find('input.productRelProcedureDescription').attr('name', 'Products[' + i + '].RelProcedureDescription');

            $(products[i]).find('select.productRemark').attr('name', 'Products[' + i + '].ProductRemark_UID');
            $(products[i]).find('input.productLotNumber').attr('name', 'Products[' + i + '].ProductLotNumber');            
        });
    },
    SortProductExportFormats: function () {
        const promises = [];
        var formats = $('#tblProductExportFormat').find('tr.productExportFormatRow');
        $.each(formats, function (i, obj) {
            promises.push(new Promise(function(resolve) {
                $(formats[i]).find('input.productEFProductName').attr('name', 'ListProductExportFormat[' + i + '].ProductName');
                $(formats[i]).find('input.productEFProduct_ID').attr('name', 'ListProductExportFormat[' + i + '].Product_UID');
                $(formats[i]).find('input.productEFName').attr('name', 'ListProductExportFormat[' + i + '].Name');
                $(formats[i]).find('input.productEFID').attr('name', 'ListProductExportFormat[' + i + '].ID');
                $(formats[i]).find('input.productEFLinkID').attr('name', 'ListProductExportFormat[' + i + '].LinkID');
                $(formats[i]).find('input.productEFGUID').attr('name', 'ListProductExportFormat[' + i + '].GUID');
                // TODO
                $(formats[i]).find('input.productEFOrderHasProduct_UID').attr('name', 'ListProductExportFormat[' + i + '].OrderHasProduct_UID');
                $(formats[i]).find('input.productEFOrderHasExport_UID').attr('name', 'ListProductExportFormat[' + i + '].OrderHasExport_UID');
                $(formats[i]).find('input.productEFDone').attr('name', 'ListProductExportFormat[' + i + '].Done');
                resolve();
            }));  
        });
        return new Promise(function(resolve) { Promise.all(promises).then(function() {resolve();})});
    },
    AddProductForRelativeProvision: function () {
        SharedOrderProductFunctions.AddProduct(SharedOrderProductFunctions.activeProduct);
        let productRowForRel = SharedOrderProductFunctions.productRowForRel;

        var productRow = $('tr#selectedProduct' + productRowForRel);
        var selectedRadio = $('input[name=procForRelProduct]:checked').parent().parent();

        var procUID = selectedRadio.find('.procForRelProduct_UID').val();
        var procCode = selectedRadio.find('.procForRelProduct_Code').val();
        var procModality = selectedRadio.find('.procForRelProduct_Modality').val();
        var procColor = selectedRadio.find('.procForRelProduct_Color').val();
        var orderProcUID = selectedRadio.find('.procForRelOrderProc_UID').val();
        var description = selectedRadio.find('.procForRelProduct_Description').val();

        let toAppend = '<b>' + procModality + '</b> ' + procCode;
        toAppend += '<input type="hidden" class="productRelOrderProcedureUID" name="Products[0].RelOrderProcedure_UID" value="' + orderProcUID + '" />';
        toAppend += '<input type="hidden" class="productRelProcedure_UID" name="Products[0].RelProcedure_UID" value="' + procUID + '" />';
        toAppend += '<input type="hidden" class="productRelProcedureCode" name="Products[0].RelProcedureCode" value="' + procCode + '" />';
        toAppend += '<input type="hidden" class="productRelProcedureModality" name="Products[0].RelProcedureModality" value="' + procModality + '" />';
        toAppend += '<input type="hidden" class="productRelativeProvision" name="Products[0].RelativeProvision" value="true" />';
        toAppend += '<input type="hidden" class="productRelProcedureColor" name="Products[0].RelProcedureColor" value="' + procColor + '" />';
        toAppend += '<input type="hidden" class="productRelProcedureDescription" name="Products[0].RelProcedureDescription" value="' + description + '" />';

        productRow.find('td.relProcCol').css('background-color', procColor);
        productRow.find('td.relProcCol').html(toAppend);
        productRow.find('td.relProcCol').attr('title', description);

        SharedOrderProductFunctions.SortSelectedProducts();
        SharedOrderFunctions.GetInvoiceInformation(true);
    },
    clampNumberInputAndAttachListener: (node, min, max, defaul, callback) => {
        $(node).on('change', (e) => {
            const input = e.currentTarget;
            const newValue = parseInt(input.value);

            let value = isNaN(newValue) ? defaul : newValue;
            if (value < min || value > (max || Number.MAX_SAFE_INTEGER))
                value = defaul;

            if (newValue != value)
                input.value = value;

            callback(value);
        })
    }
}